import { AccountSummary, FleetUser } from '@tmx/data-access';

import { LicenseUser } from '../../models/license-user';
import { createLicenseUser } from './create-license-user';

export function createLicenseUsers(
  values: FleetUser[],
  accountSummary: AccountSummary
) {
  const licenseUsers: LicenseUser[] = [];
  for (const user of values) {
    licenseUsers.push(createLicenseUser(user, accountSummary));
  }
  return licenseUsers;
}
